import { BehaviorSubject } from 'rxjs';
import { AssociatedDataEntity } from './specification-helper';
/**
 * å®ä½å±æ§å¼ååäºä»¶
 */
export const entityAttributeChange = new BehaviorSubject<{
  dataEntity: AssociatedDataEntity;
  entityAttributes: any[];
}>({
  dataEntity: undefined,
  entityAttributes: []
});
